import useCollection from "areas/collection/hoc/use-collection"

const Title = () => {
  const { data: { title } = {} } = useCollection()

  return <h1 className="h3 font-bold">{title}</h1>
}

export default Title
